import axios from '../base'
import { PlatformStatus } from './status.types'

export class StatusService {
  // GET /api/v1/status (the base instance prepends /api/v1 and attaches the
  // auth token). Returns null on any failure — for a status page an
  // unreachable endpoint IS the signal to render, so we don't toast on error.
  // Tolerates either the flat facility-facing shape or a { data: ... } envelope
  // (backend to confirm; relayed).
  getStatus = async (): Promise<PlatformStatus | null> => {
    try {
      const { data } = await axios.get('/status')
      const status = (data?.data ?? data) as PlatformStatus
      return status && status.resources ? status : null
    } catch {
      return null
    }
  }
}

export default new StatusService()
